import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

interface DateFilterState {
    invalidDateRange: boolean;
    startDate: Date | undefined;
    endDate: Date | undefined;
}

const initialState: DateFilterState = {
    invalidDateRange: false,
    startDate: undefined,
    endDate: undefined,
};

export const calendarDateFilterSlice = createSlice({
    name: 'calendarDateFilter',
    initialState,
    reducers: {
        setStartDate: (state, action: PayloadAction<Date | undefined>) => {
            state.startDate = action.payload;
            if (
                state.endDate &&
                state.startDate &&
                new Date(state.startDate) > new Date(state.endDate)
            ) {
                state.invalidDateRange = true;
            } else {
                state.invalidDateRange = false;
            }
        },
        setEndDate: (state, action: PayloadAction<Date | undefined>) => {
            state.endDate = action.payload;
            if (
                state.startDate &&
                state.endDate &&
                new Date(state.startDate) > new Date(state.endDate)
            ) {
                state.invalidDateRange = true;
            } else {
                state.invalidDateRange = false;
            }
        },
        resetDates: (state) => {
            state.invalidDateRange = false;
            state.startDate = undefined;
            state.endDate = undefined;
        },
    },
});

export const { setStartDate, setEndDate, resetDates } =
    calendarDateFilterSlice.actions;

export const selectDateFilter = (state: RootState) => state.calendarDateFilter;
export const selectInvalidDateRange = (state: RootState) =>
    state.calendarDateFilter.invalidDateRange;
export const selectStartDate = (state: RootState) =>
    state.calendarDateFilter.startDate;
export const selectEndDate = (state: RootState) =>
    state.calendarDateFilter.endDate;

export const calendarDateFilterReducer = calendarDateFilterSlice.reducer;
